import { lazy } from 'react';

const UserEdit = lazy(() => import('./UserEdit'));

export default UserEdit;
